(function () {
  function toggleSection(root, expand) {
    const content = root.querySelector('[data-cap-content]');
    const fade = root.querySelector('[data-cap-fade]');
    const btn = root.querySelector('[data-cap-toggle]');
    const labelExpand = root.dataset.labelExpand || 'Read full teaser';
    const labelCollapse = root.dataset.labelCollapse || 'Collapse';

    if (!content || !fade || !btn) return;

    if (expand) {
      content.classList.add('is-expanded');
      fade.classList.add('is-hidden');
      btn.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
      btn.querySelector('[data-cap-label]').textContent = labelCollapse;
    } else {
      content.classList.remove('is-expanded');
      fade.classList.remove('is-hidden');
      btn.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
      btn.querySelector('[data-cap-label]').textContent = labelExpand;
    }
  }

  document.addEventListener('click', function (event) {
    const btn = event.target.closest('[data-cap-toggle]');
    if (!btn) return;

    const root = btn.closest('[data-collapsible-article-preview]');
    if (!root) return;

    event.preventDefault();
    const expanded = btn.getAttribute('aria-expanded') === 'true';
    toggleSection(root, !expanded);
  });
})();
